import { render, staticRenderFns } from "./SilverCoinBox.vue?vue&type=template&id=865fc91e&scoped=true"
import script from "./SilverCoinBox.vue?vue&type=script&lang=js"
export * from "./SilverCoinBox.vue?vue&type=script&lang=js"
import style0 from "./SilverCoinBox.vue?vue&type=style&index=0&id=865fc91e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865fc91e",
  null
  
)

export default component.exports